import { Box, Typography } from '@mui/material';
import PageTitle from 'components/PageTitle';

const NotFound: React.FC = () => (
  <>
    <PageTitle title="Page Not Found" />
    <Box className="page-grid__main content" component="main">
      <Box className="content__main">
        <Box sx={{ gridColumn: 'start / end' }}>
          <Typography variant="h5">404</Typography>
        </Box>
      </Box>
    </Box>
  </>
);

export default NotFound;
